<template>
    <div class="new-resale-table">
        <div class="new-resale-modal-body-inputs-line">
            <StandardInput
                style="width: 100%"
                :action="setName"
                :value="current_user.name"
                :auto="true"
                class="new-resale-modal-input"
                title="Nome"
                type="text"
            />
        </div>
        <div class="new-resale-modal-body-inputs-line">
            <StandardInput
                :action="setPhone"
                :value="current_user.phone"
                mask="(##) #.####-####"
                :auto="true"
                class="new-resale-modal-input"
                title="Telefone"
                type="text"
            />
            <StandardInput
                :action="setEmail"
                :value="current_user.email"
                :auto="true"
                class="new-resale-modal-input"
                title="Email"
                type="text"
            />
        </div>
        <div class="new-resale-modal-body-inputs-line">
            <StandardInput
                :action="setLogin"
                :value="current_user.login"
                :auto="true"
                class="new-resale-modal-input"
                title="Login"
                type="text"
            />
            <StandardInput
                :action="setPassword"
                :value="current_user.decrypted_password"
                :auto="true"
                class="new-resale-modal-input"
                title="Senha"
                type="text"
            />
        </div>
        <div class="new-resale-modal-body-inputs-line">
            <StandardInput
                :value="selectedProfileId"
                :placeholder="getProfilePlaceholder()"
                :action="setProfile"
                :title="'Perfil'"
                :list="profileOptions"
                class="new-resale-modal-input"
                :type="'select'"
            />
        </div>
    </div>
</template>
<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import StandardInput from "@/components/ui/inputs/StandardInputV2.vue";
import { loaderMixin } from "@/mixins/sweet-loader.mixin";

export default {
    mixins: [loaderMixin],
    components: {
        ValidationProvider,
        ValidationObserver,
        StandardInput,
    },
    computed: {
        profileOptions() {
            return Array.isArray(this.profiles)
                ? this.profiles.map((profile) => ({
                      text: profile.name,
                      value: String(profile.id),
                  }))
                : [];
        },
        selectedProfileId() {
            const profileId = this.getProfileId(this.current_user && this.current_user.profile);

            return profileId != null ? String(profileId) : undefined;
        },
        selectedProfile() {
            if (!this.selectedProfileId) return null;

            return this.profileOptions.find((option) => String(option.value) === String(this.selectedProfileId)) || null;
        },
    },
    props: ["current_user", "profiles", "resale"],
    watch: {
        profiles: {
            immediate: true,
            handler() {
                this.syncSelectedProfile();
            },
        },
        current_user: {
            immediate: true,
            deep: true,
            handler() {
                this.syncSelectedProfile();
            },
        },
    },
    methods: {
        getProfileId(profile) {
            if (!profile) return null;

            return typeof profile === "object" ? profile.id : profile;
        },
        syncSelectedProfile() {
            if (!Array.isArray(this.profiles) || !this.current_user) {
                return;
            }

            const selectedProfile = this.profiles.find(
                (profile) => String(profile.id) === String(this.getProfileId(this.current_user && this.current_user.profile))
            );

            if (selectedProfile && this.current_user) {
                this.current_user.profile = selectedProfile;
            }
        },
        setName(value) {
            this.current_user.name = value;
        },
        setCpf(value) {
            this.current_user.cpf = value;
        },
        setPhone(value) {
            this.current_user.phone = value;
        },
        setEmail(value) {
            this.current_user.email = value;
        },
        setLogin(value) {
            this.current_user.login = value;
        },
        setPassword(value) {
            this.current_user.decrypted_password = value;
        },
        setProfile(value) {
            const selectedProfile = Array.isArray(this.profiles)
                ? this.profiles.find((profile) => String(profile.id) === String(value))
                : null;
            this.current_user.profile = selectedProfile || null;
        },
        getProfilePlaceholder() {
            return this.selectedProfile ? this.selectedProfile.text : "Selecione um perfil";
        },
    },
};
</script>

<style>
.new-resale-modal-body-inputs-line {
    display: flex;
    justify-content: space-between;
    margin-bottom: 2vh;
}
.new-resale-modal-input {
    width: 45%;
}

@media only screen and (max-width: 450px) {
    .new-resale-modal-body-inputs-line {
        flex-direction: column;
        gap: 1vh;
    }
    .new-resale-modal-input {
        width: 100%;
    }
}
</style>
